export default {
  iubendaPrivacyPolicyApiUrl: "https://www.iubenda.com/api/privacy-policy/67709867/no-markup",
  iubendaCookiePolicyApiUrl:
    "https://www.iubenda.com/api/privacy-policy/67709867/cookie-policy/no-markup"
};
